/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Vision UI Dashboard React base styles
import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";
import { TC } from "../../../../tokens/text";

const { transparent, white } = colors;

export default {
  styleOverrides: {
    select: {
      display: "flex !important",
      alignItems: "center !important",
      width: "100% !important",
      height: "100% !important",
      padding: `0 ${pxToRem(30)} 0 0 !important`,
      color: `#0a1628 !important`,
      backgroundColor: "transparent !important",
      cursor: "pointer !important",

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    icon: {
      color: TC.secondary,
      right: pxToRem(8),
      pointerEvents: "none",
    },
  },
};

